// Textes du lot « règles » : Règles du jeu (/regles-de-jeu, cible du QR code
// de la boîte), Commande réussie (/success) et page 404.
// RÈGLE : les valeurs françaises sont le texte EXACT du site d'avant la
// traduction — on ne réécrit pas la copie en passant.
// NB : la réponse à la question subsidiaire n'a volontairement PAS de clé :
// elle ne doit exister que dans GameRules.jsx, derrière le clic
// « parents uniquement ».
export default {
  // --- Règles du jeu : SEO ---
  'regles.seo.titre': 'Règles du jeu Joyful Reveal',
  'regles.seo.description':
    'Les règles complètes du jeu de gender reveal Joyful Reveal : formez deux équipes, répondez aux 11 questions, assemblez le puzzle et grattez la pièce finale qui révèle le sexe de bébé.',

  // --- Règles du jeu : en-tête ---
  'regles.entete.titre': 'Les règles du jeu',
  'regles.entete.introAvant':
    'Deux équipes, 11 questions, un puzzle à assembler et une pièce finale à gratter. Comptez environ',
  'regles.entete.introDuree': '20 minutes',
  'regles.entete.introEntre': ', de',
  'regles.entete.introJoueurs': '2 à 10 joueurs',

  // --- Règles du jeu : avertissement invités ---
  'regles.invite.titre': '🤫 Vous êtes invité·e à une fête ?',
  'regles.invite.destinee': 'Cette page est destinée aux',
  'regles.invite.parents': 'futurs parents',
  'regles.invite.suite':
    'qui préparent le jeu. Si vous êtes joueur, refermez-la : vous gâcheriez votre propre surprise !',

  // --- Règles du jeu : contenu du kit ---
  'regles.kit.titre': '🎁 Ce que contient votre kit',
  'regles.kit.sachetAvant': 'Un sachet principal contenant',
  'regles.kit.sachetPieces': '11 pièces de puzzle',
  'regles.kit.grattoirAvant': 'et',
  'regles.kit.grattoirPiece': 'une pièce unique à gratter',
  'regles.kit.grattoirFin': '— celle qui révèle tout.',
  'regles.kit.premium':
    'Le Pack Premium ajoute les deux pochons d’équipe, le questionnaire imprimé sur carton 400 g et l’enveloppe souvenir à glisser au dos d’un cadre après la fête.',

  // --- Règles du jeu : les 4 étapes ---
  'regles.etape1.titre': 'Avant l’arrivée des invités',
  'regles.etape1.alt':
    'Le contenu du jeu Joyful Reveal étalé : la boîte, la fiche quiz et les deux pochons',
  'regles.etape1.p1':
    'Les futurs parents choisissent les 11 questions auxquelles les joueurs devront répondre. À chaque bonne réponse, une pièce du puzzle est gagnée.',
  'regles.etape1.p2':
    'Les réponses sont toujours « maman » ou « papa » — et sont à prendre au second degré, évidemment !',
  'regles.etape1.p3':
    'Vous pouvez utiliser notre liste toute prête (plus bas) ou inventer les vôtres avec le modèle vierge.',

  'regles.etape2.titre': 'Formez les deux équipes',
  'regles.etape2.alt': 'Les deux pochons en tissu du jeu, étiquetés Équipe 1 et Équipe 2',
  'regles.etape2.p1': 'Répartissez vos invités en deux équipes — par exemple :',
  'regles.etape2.equipe1Label': 'Équipe 1',
  'regles.etape2.equipe1Texte': 'ceux qui pensent que le bébé sera une fille 💗',
  'regles.etape2.equipe2Label': 'Équipe 2',
  'regles.etape2.equipe2Texte': 'ceux qui pensent que le bébé sera un garçon 💙',

  'regles.etape3.titre': 'Le jeu : gagner les 11 pièces',
  'regles.etape3.alt': 'Dos de la boîte Joyful Reveal résumant les 4 étapes du jeu',
  'regles.etape3.p1':
    'Les futurs parents posent les questions une à une. La première équipe à donner la bonne réponse gagne une pièce du puzzle.',
  'regles.etape3.p2': 'On continue ainsi pour les 11 pièces classiques.',
  'regles.etape3.p3':
    'Une fois les 11 pièces gagnées, les deux équipes coopèrent pour assembler le puzzle… et il ne manque plus qu’une pièce !',

  'regles.etape4.titre': 'La dernière pièce : la grande révélation',
  'regles.etape4.alt': 'La boîte du jeu Joyful Reveal avec la pièce de puzzle à gratter',
  'regles.etape4.p1':
    'Seule l’équipe ayant remporté le plus de pièces a le droit de jouer cette dernière manche — et cette fois, chaque joueur joue individuellement.',
  'regles.etape4.p2':
    'Les futurs parents posent alors la question subsidiaire. Le joueur dont l’estimation est la plus proche gagne la dernière pièce… et le privilège de la gratter !',

  // --- Règles du jeu : question subsidiaire (la réponse reste dans le JSX) ---
  'regles.subsidiaire.surtitre': 'La question subsidiaire',
  'regles.subsidiaire.question':
    '« En moyenne, combien de couches jetables les jeunes parents utilisent-ils au cours de la première année de bébé ? »',
  'regles.subsidiaire.reponseLabel': 'Réponse :',
  'regles.subsidiaire.bouton': '👀 Afficher la réponse (parents uniquement)',
  'regles.subsidiaire.libre':
    'C’est notre question préférée — mais libre à vous d’en inventer une autre : il suffit que la réponse soit un nombre à estimer.',

  // --- Règles du jeu : le conseil ---
  'regles.conseil.surtitre': '💡 Petit conseil',
  'regles.conseil.titre': 'Résistez à la tentation de prévenir vos invités !',
  'regles.conseil.texte':
    'Imaginez leur réaction lorsqu’ils découvriront le jeu et réaliseront qu’ils sont sur le point de vivre un moment unique, plein de suspense. Ça vaut vraiment le coup de voir leurs visages s’illuminer. Alors tenez bon, ne soufflez pas votre secret !',

  // --- Règles du jeu : les 11 questions ---
  'regles.questions.titre': '📝 Les 11 questions prêtes à jouer',
  'regles.questions.imprimer': '🖨️ Imprimer',
  'regles.questions.q1': 'Qui est le meilleur cuisinier pour préparer les purées de bébé ?',
  'regles.questions.q2': 'Qui est le plus enclin à paniquer lors de l’accouchement ?',
  'regles.questions.q3':
    'Qui retiendra plus facilement la taille et le poids de naissance de bébé ?',
  'regles.questions.q4': 'Qui aura le plus de mal à changer les couches de bébé ?',
  'regles.questions.q5': 'Qui chantera les berceuses de manière désastreuse ?',
  'regles.questions.q6':
    'Qui ne résistera pas à acheter des vêtements mignons mais inutiles pour le bébé ?',
  'regles.questions.q7': 'Qui pleurera devant les films pour enfants ?',
  'regles.questions.q8': 'Qui fera les meilleures grimaces pour faire rire bébé ?',
  'regles.questions.q9':
    'Qui est le plus susceptible de ne pas comprendre comment enfiler les vêtements au bébé ?',
  'regles.questions.q10': 'Qui est le meilleur conteur d’histoire pour endormir bébé ?',
  'regles.questions.q11':
    'Qui pourrait maladroitement réveiller le bébé en marchant sur un jouet bruyant ?',
  'regles.questions.persoAvant':
    'Envie de personnaliser ? Remplacez librement ces questions par les vôtres — l’essentiel est que la réponse soit toujours',
  'regles.questions.persoMaman': '« maman »',
  'regles.questions.persoOu': 'ou',
  'regles.questions.persoPapa': '« papa »',
  'regles.questions.persoFin': '. Le Pack Premium contient un modèle vierge prévu pour ça.',

  // --- Règles du jeu : CTA final ---
  'regles.cta.titre': 'Pas encore votre jeu ?',
  'regles.cta.texte': 'Amusez-vous bien — et encore félicitations à vous, futurs parents ! 🎉',
  'regles.cta.bouton': '🛒 Découvrir le jeu',

  // --- Page 404 (NotFound.jsx), rangée sous « regles » faute d'espace dédié ---
  'regles.introuvable.seoTitre': '404 - Page Non Trouvée',
  'regles.introuvable.seoDescription':
    "La page que vous recherchez n'existe pas. Retournez à l'accueil ou explorez notre boutique.",
  'regles.introuvable.titre': '404 - Oups !',
  'regles.introuvable.sousTitre': "La page que vous recherchez n'a pas pu être trouvée.",
  'regles.introuvable.texte':
    "Il est possible que la page ait été supprimée, déplacée, ou que l'URL soit incorrecte.",
  'regles.introuvable.boutonAccueil': "🏠 Retour à l'Accueil",
  'regles.introuvable.boutonBoutique': '🛍️ Voir la Boutique',
  'regles.introuvable.aide': "Besoin d'aide ?",
  'regles.introuvable.aideLien': 'Contactez-nous',

  // --- Commande réussie (Success.jsx) ---
  'succes.chargement.titre': 'Finalisation de votre commande...',
  'succes.chargement.texte':
    'Nous récupérons votre numéro de suivi, cela ne devrait pas être long.',
  'succes.entete.titre': 'Commande Réussie !',
  'succes.entete.numeroLabel': 'Numéro de commande:',
  'succes.entete.merci':
    'Merci pour votre achat ! Vous allez recevoir un email de confirmation avec les détails de votre commande et votre facture.',
  'succes.suivi.titre': 'Suivi de votre colis',
  'succes.suivi.etiquette': "Votre étiquette d'expédition a été créée !",
  'succes.suivi.numeroLabel': 'N° de suivi:',
  'succes.suivi.bouton': '🚚 Suivre mon colis',
  'succes.suivi.astuce':
    '💡 Vous pouvez aussi retrouver ce lien dans votre profil → Mes commandes',
  'succes.attente.texte':
    'Votre commande est en cours de traitement. Le numéro de suivi sera bientôt disponible dans votre espace client.',
  // Guide de règles téléchargeable. Il contient la réponse de la question
  // subsidiaire : l'avertissement n'est pas décoratif.
  // Affiché quand la session de paiement n'est plus lisible (lien rouvert
  // des semaines plus tard) : la page restait alors amputée EN SILENCE —
  // ni numéro de commande, ni guide, ni facture, et aucune explication.
  'succes.introuvable.texte':
    "Votre paiement est bien passé. Nous n'arrivons simplement pas à afficher le détail de cette commande ici — cela arrive quand ce lien est rouvert plus tard. L'e-mail de confirmation contient votre numéro de commande et votre facture ; écrivez-nous si vous ne le retrouvez pas.",
  'succes.guide.titre': 'Votre guide du jeu',
  'succes.guide.texte':
    'Le livret complet, avec les 11 questions prêtes à jouer et le modèle vierge pour écrire les vôtres. Gardez-le sous la main le jour J.',
  'succes.guide.bouton': '📥 Télécharger le guide (PDF)',
  'succes.guide.avertissement':
    '⚠️ Réservé aux futurs parents : il révèle la réponse de la question subsidiaire.',

  // Questionnaire souvenir téléchargeable (rempli ou vierge). Son verso porte
  // lui aussi la réponse de la question subsidiaire : même garde que le guide.
  'succes.questionnaire.titre': 'Votre questionnaire souvenir',
  'succes.questionnaire.texte':
    'La fiche quiz prête à imprimer, au format de la carte du kit : les 11 questions et les colonnes des équipes. Cochez la case pour une version vierge, à remplir avec vos propres questions.',
  'succes.questionnaire.vierge': 'Version vierge (pour écrire vos propres questions)',
  'succes.questionnaire.bouton': '📥 Télécharger le questionnaire (PDF)',
  'succes.questionnaire.avertissement':
    '⚠️ Réservé aux futurs parents : son verso révèle la réponse de la question subsidiaire.',

  "succes.facture.titre": "Votre facture",
  "succes.facture.texte":
    "La facture de votre commande est prête. Stripe vous envoie aussi un reçu de paiement par e-mail.",
  "succes.facture.bouton": "🧾 Voir et imprimer la facture",
  'succes.avis.titre': 'Votre avis compte !',
  'succes.avis.texte':
    "Partagez votre expérience et aidez d'autres clients à découvrir nos produits.",
  'succes.avis.bouton': '✍️ Laisser un avis',
  'succes.actions.commandes': '📋 Voir mes commandes',
  'succes.actions.boutique': '🎮 Continuer vos achats',
};
